// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2oAQe","filesListContainer":"PosDisputesFiles_filesListContainer__IELZz","filesButton":"PosDisputesFiles_filesButton__1ZqzF"};